<app-cer-list />
<button mat-fab matTooltip="Aggiungi nuovo sito" routerLink="/administration/cer/add" class="addButton bg-primary">
    <mat-icon>add</mat-icon>
</button>